// excelParser.ts
export function parseDPCRExcel(file: File): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const buffer = e.target?.result as ArrayBuffer;
      try {
        // Create a new Worker instance using the module syntax.
        const worker = new Worker(new URL("./excelWorker.ts", import.meta.url), { type: "module" });
        worker.onmessage = (e: MessageEvent) => {
          // If the worker returns an error object, reject the promise.
          if (e.data && e.data.error) {
            reject(new Error(e.data.error));
          } else {
            resolve(e.data);
          }
          worker.terminate();
        };
        worker.onerror = (e) => {
          reject(new Error(e.message));
          worker.terminate();
        };
        worker.postMessage(buffer);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsArrayBuffer(file);
  });
}
